import TrafficLightIcon from './component'

export default TrafficLightIcon
